export default class KeyFigureDto {
    constructor(user) {
        this.value = user.value
        this.title = user.title
    }
}